import { Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import Cookies from "js-cookie";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import AppContext from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { fetchTasks } from "../../service/Task";
import CommonButton from "../../components/common/CommonButton";
import translations from "../../components/common/Translations";
import ModalCloseButton from "../../components/common/ModalCloseButton";
import { filterAgentsByCurrentUserGroups } from "../../components/task/GroupAssignParts";
export default function FieldAgentModal({
  setAssignOpen,
  assignOpen,
  handleSaveTask,
  selectedfieldAgent,
  setselectedfieldAgent,
  isCreateLoading
}) {
  const context = useContext(AppContext);
  const {
    workflowId,
    setSelectAll,
    userType,
    setPriority,
    setActive,
    setSelectedUserId,
    setSelectedUserName,
    selectedOrgId,
  } = context;
  const [fieldAgent, setFieldAgent] = useState();
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // New state variable
  const cancelButtonRef = useRef(null);
  const { theme, langMode, activityId } = useContext(AppContext);
  const [allFieldAgents, setAllFieldAgents] = useState([]);
  const [displayedAgents, setDisplayedAgents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  useEffect(() => { }, [fieldAgent]);

  useEffect(() => {
    console.log("activity id: ", activityId)
    if (assignOpen && !isDataFetched && activityId) {
      const fetchData = (activityId) => {
        const token = Cookies.get("accessToken");
        let organizationQuery = "";
        if (userType === "super_admin" && selectedOrgId) {
          organizationQuery = `&organizationId=${selectedOrgId}`;
        }
       
        // resolved params issue by harshit vachhani
        if (!activityId) {
          return;
        }
        axios
          .get(
            `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/user/field-agents-by-workflow?workflowId=${activityId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(async (response) => {
            const rawAgents = response?.data?.body?.value;
            // Only show field agents who belong to a group assigned to this user
            // (blank group list => show all).
            const agents = rawAgents
              ? await filterAgentsByCurrentUserGroups(rawAgents)
              : rawAgents;
            if (agents) {
              setFieldAgent(agents);
              setAllFieldAgents(agents);
              setDisplayedAgents(agents); // Show first 10 records initially
            } else {
              setError("No field agents found");
            }
            setIsDataFetched(true);
          })
          .catch((error) => {
            console.error("An error occurred:", error);
          });
      };
      fetchData(activityId);
    }
    if (!assignOpen) {
      setIsDataFetched(false);
    }
  }, [assignOpen, isDataFetched]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredAgents = allFieldAgents.filter(agent =>
      agent.name.toLowerCase().includes(query)
    );
    setDisplayedAgents(filteredAgents);
  };

  const handleFieldAgentSelect = (userId) => {
    setselectedfieldAgent((prevAgents) => {
      let updatedAgents;
      if (prevAgents.includes(userId)) {
        updatedAgents = prevAgents.filter((agentId) => agentId !== userId); // Deselect
      } else {
        updatedAgents = [...prevAgents, userId]; // Select
      }
      console.log("Updated Field Agents: ", updatedAgents); // Log updated list
      return updatedAgents;
    });
  };

  return (
    <Transition.Root show={assignOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setAssignOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-[1px] transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          {/* ? changed items-end ? items-center to center modal vertically */}
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-2xl border border-slate-100 bg-white text-left shadow-2xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                  }`}
              >
                <div
                  className={`bg-white rounded-2xl shadow ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4 dark:border-gray-600">
                    <h3 className="text-lg font-semibold text-slate-800 dark:text-white">
                      {translations[langMode].FieldStaffList}
                    </h3>
                    <div className="flex items-center gap-3">
                      <CommonButton colorIntent="success"
                        disabled={selectedfieldAgent.length === 0}
                        onClick={handleSaveTask}
                        variant="primary"
                        tooltipText={
                          selectedfieldAgent.length === 0
                            ? translations[langMode].selectatleast
                            : isCreateLoading
                              ? translations[langMode].assingmentinprocess
                              : translations[langMode].assingselectedtasktochosen
                        }
                        tooltipPosition="top"
                        className={`rounded-lg px-4 py-1.5 text-sm shadow-sm whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed ${
                          isCreateLoading ? "bg-opacity-60" : "bg-opacity-100"
                        }`}
                      >
                        {isCreateLoading
                          ? translations[langMode].Assigning
                          : translations[langMode].assign}
                      </CommonButton>
                      <ModalCloseButton
                        onClick={() => {
                          setAssignOpen(false);
                          setselectedfieldAgent([]);
                        }}
                        ariaLabel="Close modal"
                      />
                    </div>
                  </div>

                  <div className="p-2 md:p-5 space-y-2 overflow-y-auto max-h-[250px]">
                    <input
                      type="text"
                      placeholder={translations[langMode].searchfieldAgent}
                      value={searchQuery}
                      onChange={handleSearch}
                      className="w-full mb-2 p-2 border border-slate-200 bg-slate-50 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#236DB4]/20 focus:border-[#236DB4]"
                    />
                    {error ? (
                      <div className="text-red-500">{error}</div>
                    ) : (
                      displayedAgents &&
                      displayedAgents.map((agent) => (
                        <div
                          key={agent.userId}
                          className={`bg-white p-2.5 rounded-lg hover:bg-slate-50 ${theme === "dark"
                            ? "dark-mode"
                            : theme === "high-contrast"
                              ? "high-contrast"
                              : ""
                            }`}
                        >
                          <label className="flex items-center gap-2.5 cursor-pointer">
                            <input
                              type="checkbox"
                              onClick={() =>
                                handleFieldAgentSelect(agent.userId)
                              }
                              checked={selectedfieldAgent.includes(agent.userId)}
                              className="w-4 h-4 accent-[#236DB4] rounded border-slate-300"
                            />
                            <span
                              className="text-sm font-medium text-slate-700 dark:text-gray-300"
                            >
                              {agent.name}
                            </span>
                          </label>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>

  );
}
